export const decisionIssueDefaultText = `
<p data-placeholder="State the problem"></p>
<h2>What I did to help create this situation</h2>
<p data-placeholder="Make an honest effort to declare how you contributed to creating the situation."></p>
<h2>Proposed solution</h2>
<p data-placeholder="You can likely reverse those steps if you have done a good job of declaring how you helped create the situation. Either way, write out a solution with proposed actions."></p>
<h2>Video</h2>
<p data-placeholder="Now that you have written the issue/proposed solution, please record a Loom video of yourself describing each of the steps above."></p>
`
